const availabilityTime = [
  { value: 1800, text: '30 minutes' },
  { value: 3600, text: '1 heure' },
  { value: 7200, text: '2 heures' },
  { value: 14400, text: '4 heures' },
  { value: 43200, text: '12 heures' },
  { value: 86400, text: '24 heures' },
];

export default availabilityTime;
